import { Validator } from '@vista-digital/validator';
import { cdnStandardAssetOptionsValidator } from '../../../../validators/cdn-asset-options';
export const defaultFilmSummaryCdnOptions = {
    filmThumbnailImage: { width: 200 }
};
export const filmSummaryCdnOptionsValidatorSchema = {
    filmThumbnailImage: cdnStandardAssetOptionsValidator
};
export const filmSummaryCdnOptionsValidator = Validator.object(filmSummaryCdnOptionsValidatorSchema);
//# sourceMappingURL=cdn-options.js.map